/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: DXsJbV2y7Z3n
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: CF9w0NRrnxvp/component
import SectionHero from "../../SectionHero"; // plasmic-import: LAgK4hEGm2TV/component
import TopNav from "../../TopNav"; // plasmic-import: MzgISFkf8fEm/component
import ButtonPage from "../../ButtonPage"; // plasmic-import: voJV0X1zqcH0/component
import HeroUnerline from "../../HeroUnerline"; // plasmic-import: pfVxagK4NBto/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: NAltgsviawN1/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: DXsJbV2y7Z3n/css

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <SectionHero
                  data-plasmic-name={"sectionHero"}
                  data-plasmic-override={overrides.sectionHero}
                  className={classNames("__wab_instance", sty.sectionHero)}
                  colWidth={"medium"}
                  navbar={
                    <TopNav
                      data-plasmic-name={"topNav"}
                      data-plasmic-override={overrides.topNav}
                      className={classNames("__wab_instance", sty.topNav)}
                      pageButtons={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__xinKi
                            )}
                          >
                            {"["}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__i4P
                            )}
                            content={"overview"}
                            isSelected={true}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOverview"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOverview"] != null &&
                                typeof $steps["goToPartnerOverview"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOverview"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOverview"] =
                                  await $steps["goToPartnerOverview"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__tbSUw
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__a2SSh
                            )}
                            content={"mission"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerMission"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/mission`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerMission"] != null &&
                                typeof $steps["goToPartnerMission"] ===
                                  "object" &&
                                typeof $steps["goToPartnerMission"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerMission"] =
                                  await $steps["goToPartnerMission"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__odtK8
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__bngfY
                            )}
                            content={"the independent"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOpenCall"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/the-independent`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOpenCall"] != null &&
                                typeof $steps["goToPartnerOpenCall"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOpenCall"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOpenCall"] =
                                  await $steps["goToPartnerOpenCall"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___6I6Hl
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__dvXjs
                            )}
                            content={"early bird"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToEarlyBird"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/early-bird`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToEarlyBird"] != null &&
                                typeof $steps["goToEarlyBird"] === "object" &&
                                typeof $steps["goToEarlyBird"].then ===
                                  "function"
                              ) {
                                $steps["goToEarlyBird"] =
                                  await $steps["goToEarlyBird"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___0ZTw
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__j66B0
                            )}
                            content={"contact"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSupport"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/support"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSupport"] != null &&
                                typeof $steps["goToHttpsO21PComSupport"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSupport"]
                                  .then === "function"
                              ) {
                                $steps["goToHttpsO21PComSupport"] =
                                  await $steps["goToHttpsO21PComSupport"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__lstMh
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__aLiJu
                            )}
                            content={"join the community"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComPartnersCommunity"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination:
                                        "https://o21p.com/partners-community"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComPartnersCommunity"] !=
                                  null &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ] === "object" &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ].then === "function"
                              ) {
                                $steps["goToHttpsO21PComPartnersCommunity"] =
                                  await $steps[
                                    "goToHttpsO21PComPartnersCommunity"
                                  ];
                              }
                            }}
                            textColor={"brand"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__nhN4Y
                            )}
                          >
                            {"]"}
                          </div>
                        </React.Fragment>
                      }
                    />
                  }
                  sectionId={"top"}
                  showTagline={false}
                  slot={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hEfzn
                      )}
                    >
                      {"Dentistry doesn't burn you out. Everything else does."}
                    </div>
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__usds
                    )}
                  >
                    {"like having\n25 hours in a day."}
                  </div>
                </SectionHero>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames(projectcss.all, sty.s1)}
                >
                  <div
                    data-plasmic-name={"container"}
                    data-plasmic-override={overrides.container}
                    className={classNames(projectcss.all, sty.container)}
                  >
                    <div
                      data-plasmic-name={"wrapperDiv"}
                      data-plasmic-override={overrides.wrapperDiv}
                      className={classNames(projectcss.all, sty.wrapperDiv)}
                    >
                      <HeroUnerline
                        data-plasmic-name={"heroUnerline"}
                        data-plasmic-override={overrides.heroUnerline}
                        className={classNames(
                          "__wab_instance",
                          sty.heroUnerline
                        )}
                      />

                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__feMVj
                        )}
                      >
                        {"Dear practice builder,"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__tqpjw
                        )}
                      >
                        {"I know what this looks like from the outside."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__qpUcg
                        )}
                      >
                        {"Another marketing message."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__aOgPl
                        )}
                      >
                        {"Another \u201csolution.\u201d"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p___2PUt7
                        )}
                      >
                        {
                          "Another pitch about a product supposedly tailored to your practice, one that promises to fix everything."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__kqhrj
                        )}
                      >
                        {"This isn\u2019t that."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__hAgHk
                        )}
                      >
                        {"I\u2019ll keep it brief."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__sduuo
                        )}
                      >
                        {"TL;DR:"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__hS0I
                        )}
                      >
                        {
                          "What you\u2019ll find here is a concept, and an invitation, that\u2019s becoming more relevant as the pressure of consolidation and its consequences begin to undermine the work you love."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__gji6V
                        )}
                      >
                        {"That\u2019s it."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__lWv3A
                        )}
                      >
                        {
                          "But if you\u2019d rather read on, here\u2019s a bit more on that:"
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__wXaKp
                        )}
                      >
                        {"Every era has its builders."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__h3HbB
                        )}
                      >
                        {"pargraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__mVroj
                        )}
                      >
                        {"pargraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__v6Z6
                        )}
                      >
                        {"pargraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p___4WKV
                        )}
                      >
                        {"pargraph"}
                      </p>
                    </div>
                  </div>
                </section>
                <SectionFooter
                  data-plasmic-name={"sectionFooter"}
                  data-plasmic-override={overrides.sectionFooter}
                  className={classNames("__wab_instance", sty.sectionFooter)}
                  layout={"withOffset"}
                  sectionId={"footer"}
                />
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          {(hasVariant(globalVariants, "screen", "tablet") ? true : false) ? (
            <div
              data-plasmic-name={"noBudgetSmallScreens"}
              data-plasmic-override={overrides.noBudgetSmallScreens}
              className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mKveA
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rs8Ua
                )}
              >
                {
                  "our massive development budget is dedicated to designing and building the platform for larger screens."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qVq
                )}
              >
                {"\u2013 at least 900px wide \u2013"}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "pageLayout",
    "sectionHero",
    "topNav",
    "s1",
    "container",
    "wrapperDiv",
    "heroUnerline",
    "sectionFooter",
    "noBudgetSmallScreens"
  ],

  pageLayout: [
    "pageLayout",
    "sectionHero",
    "topNav",
    "s1",
    "container",
    "wrapperDiv",
    "heroUnerline",
    "sectionFooter"
  ],

  sectionHero: ["sectionHero", "topNav"],
  topNav: ["topNav"],
  s1: ["s1", "container", "wrapperDiv", "heroUnerline"],
  container: ["container", "wrapperDiv", "heroUnerline"],
  wrapperDiv: ["wrapperDiv", "heroUnerline"],
  heroUnerline: ["heroUnerline"],
  sectionFooter: ["sectionFooter"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    topNav: makeNodeComponent("topNav"),
    s1: makeNodeComponent("s1"),
    container: makeNodeComponent("container"),
    wrapperDiv: makeNodeComponent("wrapperDiv"),
    heroUnerline: makeNodeComponent("heroUnerline"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "o21p | partner",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
